// modules
import { ViewChild, ɵɵsetComponentScope } from '@angular/core';
import { Component, Inject, Input, OnInit, EventEmitter, Output, ElementRef } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { filter, Observable, of as observableOf, timer } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';
import { ViewEncapsulation } from '@angular/core';

// components
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';

// services
import { BaseLocalStorageService } from 'src/app/service/base-local-storage.service';
import { DistrictEntityService } from '../../service/district-entity.service';
import { Region } from '../../../../model/region.model';
import { County } from 'src/app/model/county';
import { HelperService } from 'src/app/service/helper.service';
import { PagingService } from 'src/app/service/paging.service';

@Component({
    selector: 'app-search-district',
    templateUrl: './search-district.component.html',
    styleUrls: ['./search-district.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SearchDistrictComponent implements OnInit {
    @ViewChild(MatPaginator) districtPaginator: MatPaginator;
    @Output() eventEmitterDistrict = new EventEmitter<SchoolDistrict[]>();
    @Output() eventUpdateCounter = new EventEmitter<boolean>();
    @Output() onCheckCloseDialogEvent: EventEmitter<boolean> = new EventEmitter();
    @Input() filterPlaceholder: string = '';
    @Input() selectLabel: string = '';
    @Input() selectDistrict: string = '';

    @Input() reset: boolean;
    @ViewChild('filterRef') filterElement!: ElementRef;

    // main properties
    private readonly _matDialogRef: MatDialogRef<SearchDistrictComponent>;
    private readonly triggerElementRef: ElementRef;
    baseLocalStorageService: any;
    bCheckAll: boolean = false;
    checkedList: boolean[] = [];
    dataSource = new MatTableDataSource<SchoolDistrict>();
    bHideIDCol = false;
    selection = new SelectionModel<SchoolDistrict>(true, []);
    localStorageInfo$: Observable<any> = new Observable();
    isLoadingResults = false;
    displayedColumns: string[] = ['select', 'ID', 'DISTRICTS']; // ,'ID','select', 'ORGANIZATIONS_ID', 'NCESDist', 'CODE','CREATED_BY', 'CREATED_DATE', 'MODIFIED_BY', 'MODIFIED_DATE', 'ORGANIZATION', 'COUNTY'
    showSpinner = true;
    districtForm!: UntypedFormGroup;
    districts$: Observable<SchoolDistrict[]>;
    lstDistrict: SchoolDistrict[] = [];
    regions: Region[] = [];
    counties: County[] = [];
    resetDistrict: boolean = false;
    promises: Array<any> = [];
    //Total district from NGRX
    districts: SchoolDistrict[] = [];
    districtCodes: number[] = [];
    myData: SchoolDistrict[] = [];
    bPrintOnce: boolean = false;
    tooltipSearch: string = 'Search';
    tooltipClearFilter: string = 'Clear filter';

    constructor(
        private fb: UntypedFormBuilder,
        private districtService: DistrictEntityService,
        _baseLocalStorageService: BaseLocalStorageService,
        private helperService: HelperService,
        public dialogRef: MatDialogRef<SearchDistrictComponent>,
        public pagingService: PagingService,
        @Inject(MAT_DIALOG_DATA) data: { trigger: ElementRef; reset: boolean; selectDistrict: string }
    ) {
        this._matDialogRef = dialogRef;
        this.triggerElementRef = data.trigger;
        this.reset = data.reset;

        this.selectDistrict = data.selectDistrict;
        Object.values(data.selectDistrict).forEach((item) => {
            this.districtCodes.push(parseInt(item));
        });
        console.log('selectDistrict coming in dialog as: ' + Object.entries(this.districtCodes));

        this.districts$ = districtService.entities$;

        this.populateDistricts();

        this.subscribers();
        this.showSpinner = true;

        this.districtForm = this.fb.group({
            districtSelect: [''],
            districtSelectTableCheckboxes: [''],
            txtFilter: ['']
        });
        // prep localStorage
        this.baseLocalStorageService = _baseLocalStorageService;
        this.localStorageInfo$ = _baseLocalStorageService.myData$;

        // handle a parent component's setting of selectedDistrict
        if (this.districtCodes) {
            console.log('district parent attempting to set selecteddistrict:');
            this.districtCodes.forEach((item) => {
                console.log(item);
                this.checkedList[item] = true;
            });
            this.fnProcessFilter(false);
        }

        try {
            // console.log("now prepping localStorage for lastCheckedList")
            // set persisted check selections here
            this.checkedList = this.baseLocalStorageService?.getInfo('lastCheckedList');

            if (this.checkedList) {
                // initialize this array to all false
                // console.log("found checkedList local storage")
                this.dataSource.data.forEach((x) => {
                    //console.log("now spinning through data rows for checkedList:" + x.ID + ":" + Boolean(this.checkedList[x.ID]))
                    if (this.checkedList[x.ID]?.toString() == 'true') {
                        this.selection.select(x);
                    }
                });
            }
        } catch (Err) {
            console.log('Error, but likely no localStorage yet for checkedLists:' + Err);
        }

        // console.log("reset districts:" + this.reset)
        if (this.reset) {
            console.log('reset districts called');
            this.deSelectAll();
        }
    }

    ngOnInit() {
        const matDialogConfig: MatDialogConfig = new MatDialogConfig();
        const rect = this.triggerElementRef.nativeElement.getBoundingClientRect();
        matDialogConfig.position = { left: `${rect.left}px`, top: `${rect.bottom}px` };
        this._matDialogRef.updatePosition(matDialogConfig.position);
        if (this.reset) {
            console.log('reset districts called');
            this.deSelectAll();
        }
    }

    ngOnChanges(): void {
        if (this.reset) {
            console.log('reset districts called');
            this.deSelectAll();
        }
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.districtPaginator;
    }

    ngOnDestroy() {
        this.fnProcessFilter(false);
    }

    populateDistricts() {
        this.districts$.subscribe((x) => {
            x.forEach((y) => {
                this.districts.push(y);
            });
        });
    }

    subscribers() {
        this.helperService.selectedRegions$.subscribe((x: Region[]) => {
            if (x?.length <= 0) {
                this.helperService.lstUserProfileRegion$.subscribe((y: Region[]) => {
                    this.regions = y;
                    this.populateMatTable();
                });
            } else {
                this.regions = x;
                this.populateMatTable();
            }
        });

        this.helperService.selectedCounties$.subscribe((x) => {
            this.counties = x;
            this.populateMatTable();
        });

        this.selection.changed.subscribe((x) => {
            this.helperService.setSelectedDistrictObject(x.source.selected);
        });
    }

    populateMatTable() {
        this.myData = [];

        if (this.counties?.length > 0) {
            this.regions.forEach((lstRegion) => {
                console.log('Region OrgID:' + lstRegion.ORGANIZATIONS_ID);
                this.counties.forEach((lstCounty) => {
                    console.log('County OrgId:' + lstCounty.ORGANIZATIONS_ID);
                    let retDistrict = this.districts.filter(function (d) {
                        return d.COUNTy.ORGANIZATIONS_ID === lstCounty.ORGANIZATIONS_ID && d.REGION.ORGANIZATIONS_ID === lstRegion.ORGANIZATIONS_ID;
                    });
                    //This is the not correct way to assign, but for some reason, it is allowing me to do this option only
                    retDistrict.forEach((d) => {
                        if (this.myData?.findIndex((element) => element.ORGANIZATIONS_ID == d.ORGANIZATIONS_ID) == -1) this.myData.push(d);
                    });
                });
            });
        } else {
            this.regions.forEach((item) => {
                let retDistrict = this.districts.filter(function (d) {
                    return d.REGION.ID === item.ID;
                });
                //This is the not correct way to assign, but for some reason, it is allowing me to do this option only
                retDistrict.forEach((d) => this.myData.push(d));
            });
        }

        this.dataSource.data = this.myData;
    }

    setSelectedDistrict() {
        console.log('searchdistrict control now executing setSelectedDistrict');
        console.log(this.selectDistrict);
        // set input regionid as selected
        if (this.selectDistrict) {
            console.log('search district controller now setting value:' + this.selectDistrict);

            this.districtForm.controls['districtSelect'].setValue(this.selectDistrict);
        }
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        if (!this.bPrintOnce) {
            console.log(this.selection.selected.length + '-----' + this.dataSource.data.length);
            this.bPrintOnce = true;
        }
        return numSelected === numRows;
    }

    deSelectAll() {
        this.reset = false;

        if (this.checkedList) {
            //let i = 0;

            this.dataSource.data.forEach((x) => {
                // this.selectHandler(x.ID);
                this.checkedList[x.ID] = false;
                // i = i + 1;
            });
        }
        this.bCheckAll = false;
        this.selection.clear();
    }

    masterToggle() {
        if (this.bCheckAll) {
            this.deSelectAll();
            return;
        }
        this.fnCheckAll();
    }

    fnCheckAll() {
        this.bCheckAll = true;
        if (!this.checkedList) {
            this.checkedList = [];
        }

        let i = 0;
        this.dataSource.data.forEach((x) => {
            this.checkedList[x.ID] = true;
            this.selection.select(x);
        });
    }

    fnProcessFilter(bCloseWindow: boolean) {
        try {
            if (this.checkedList) {
                const jsonData = JSON.stringify(this.checkedList); // checkedList
                localStorage.setItem('lastCheckedList', jsonData);

                this.helperService.selectedDistrict$.subscribe((x) => {
                    this.lstDistrict = x;
                });
                this.eventEmitterDistrict.emit(this.lstDistrict);
                console.log('localstorage update');
            }
        } catch (Err) {
            console.log('localStorage error: ' + Err);
        }
        if (bCloseWindow) {
            // we dont want to close the window if the user made selections but then hits clear-filter, which will make a call to this method
            this.fnCloseDialog();
            this.dialogRef.close();
        }
    }

    fnSelectRow(row: any) {
        let bVal: boolean = false;
        let rowId: number = row.ID;
        this.selection.toggle(row);

        if (!this.checkedList) {
            this.checkedList = [];
            let i = 0;
            this.dataSource.data.forEach((x) => {
                this.checkedList[x.ID] = false;
            });
            this.deSelectAll();
        }
        if (this.checkedList[rowId] == undefined || this.checkedList[rowId] === null) {
            //    console.log('set a blank checkbox to default');
            this.checkedList[rowId] = false;
            bVal = false;
        }
        if (!this.checkedList[rowId]) {
            this.checkedList[rowId] = true;
            bVal = true;
        } else {
            this.checkedList[rowId] = false;
            bVal = false;
        }
        this.eventUpdateCounter.emit(true);
        console.log('this row was selected:' + Object.entries(row) + ' to be ' + bVal);
    }

    fnCloseDialog() {
        this.onCheckCloseDialogEvent.emit(false);
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        if (filterValue) {
            this.dataSource.filter = filterValue.trim().toLowerCase();
        } else {
            this.dataSource.filter = '';
        }
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    fnReset(evt: Event) {
        this.districtForm.controls['txtFilter'].reset();

        this.applyFilter(evt);
    }

    onBlur() {
        this.fnProcessFilter(false);
    }
}
